import * as React from 'react';

import { cn } from '@/utils/index';

const Card = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('rounded-surface bg-fill-background-neutral text-text-default-primary flex h-fit flex-col p-12', className)} {...props} />
);

const CardHeader = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('mt-2 mb-10 flex flex-col gap-4', className)} {...props} />
);

type CardTitleProps = React.HTMLAttributes<HTMLHeadingElement> & {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

const CardTitle = ({ className, as: Component = 'h1', ...props }: CardTitleProps) => (
  <Component className={cn('text-heading-l-semibold', className)} {...props}>
    {props.children}
  </Component>
);

const CardDescription = ({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cn('text-text-default-secondary text-body-m-regular', className)} {...props} />
);

const CardContent = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('text-body-m-regular flex-1', className)} {...props} />
);

const CardFooter = ({ className, isStickyOnMobile = false, ...props }: React.HTMLAttributes<HTMLDivElement> & { isStickyOnMobile?: boolean }) => (
  <div
    className={cn(
      'mt-6 flex items-center',
      isStickyOnMobile && 'max-tablet:sticky max-tablet:bottom-0 max-tablet:mt-auto max-tablet:bg-fill-background-neutral max-tablet:py-4',
      className,
    )}
    {...props}
  />
);

export { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle };
